import { apiFetch } from "./client";

export function fetchAdminProducts(collectionName, sortBy) {
  const qs = new URLSearchParams();
  if (collectionName) qs.set("CollectionName", collectionName);
  if (sortBy) qs.set("SortBy", sortBy);
  const query = qs.toString();
  return apiFetch(`/api/admin/product${query ? `?${query}` : ""}`);
}

export function fetchAdminOrders({ page = 1, pageSize = 15, status, userId, fromDate, toDate } = {}) {
  const qs = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  if (status != null && status !== "") qs.set("status", String(status));
  if (userId != null && userId !== "") qs.set("UserId", String(userId));
  if (fromDate != null && fromDate !== "") qs.set("fromDate", String(fromDate));
  if (toDate != null && toDate !== "") qs.set("toDate", String(toDate));
  return apiFetch(`/api/admin/orders?${qs}`);
}

export function searchAdminUsers(email, page = 1, pageSize = 5) {
  const qs = new URLSearchParams({ Email: email, Page: String(page), PageSize: String(pageSize) });
  return apiFetch(`/api/admin/user?${qs}`);
}

export function fetchAdminOrder(orderId) {
  return apiFetch(`/api/admin/orders/${encodeURIComponent(orderId)}`);
}

export function adminMarkShipped(orderId) {
  return apiFetch(`/api/admin/orders/${encodeURIComponent(orderId)}/ship`, {
    method: "POST",
  });
}

export function adminMarkDelivered(orderId) {
  return apiFetch(`/api/admin/orders/${encodeURIComponent(orderId)}/deliverd`, {
    method: "POST",
  });
}

export function adminCancelOrder(orderId, returnAmount) {
  return apiFetch(`/api/admin/orders/${encodeURIComponent(orderId)}/cancel`, {
    method: "POST",
    body: JSON.stringify({ returnAmount }),
  });
}

export function adminPartialReturn(orderId, returnItems, cod) {
  return apiFetch(`/api/admin/orders/${encodeURIComponent(orderId)}/return`, {
    method: "POST",
    body: JSON.stringify({ returnItems, cod }),
  });
}

export function adminPartialExchange(orderId, requestData) {
  return apiFetch(`/api/admin/orders/${encodeURIComponent(orderId)}/exchange`, {
    method: "POST",
    body: JSON.stringify(requestData),
  });
}

export function deleteAdminProduct(productId) {
  return apiFetch(`/api/admin/product/${encodeURIComponent(productId)}`, {
    method: "DELETE",
  });
}

export function createAdminProduct(body) {
  return apiFetch(`/api/admin/product`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

// Single product (admin view with variants)
export function fetchAdminProduct(productId) {
  return apiFetch(`/api/admin/product/${encodeURIComponent(productId)}`);
}

// Update product basic info
export function updateProduct(productId, body) {
  return apiFetch(`/api/admin/product/${encodeURIComponent(productId)}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
}

// Product images
export function addProductImage(productId, file) {
  const form = new FormData();
  form.append("image", file);
  return apiFetch(`/api/admin/product/${encodeURIComponent(productId)}/images`, {
    method: "POST",
    body: form,
  });
}

export function deleteProductImage(productId, imageId) {
  return apiFetch(
    `/api/admin/product/${encodeURIComponent(productId)}/images/${encodeURIComponent(imageId)}`,
    { method: "DELETE" }
  );
}

export function updateImagesOrder(productId, imagesVaraintList) {
  return apiFetch(`/api/admin/product/${encodeURIComponent(productId)}/images`, {
    method: "PUT",
    body: JSON.stringify({ imagesVaraintList }),
  });
}

// Size variants
export function addSizeVariant(productId, body) {
  return apiFetch(`/api/admin/product/${encodeURIComponent(productId)}/size`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateSizeVariant(productId, sizeId, body) {
  return apiFetch(
    `/api/admin/product/${encodeURIComponent(productId)}/size/${encodeURIComponent(sizeId)}`,
    { method: "PUT", body: JSON.stringify(body) }
  );
}

export function deleteSizeVariant(productId, sizeId) {
  return apiFetch(
    `/api/admin/product/${encodeURIComponent(productId)}/size/${encodeURIComponent(sizeId)}`,
    { method: "DELETE" }
  );
}

// Color variants
export function addColorVariant(productId, body) {
  return apiFetch(`/api/admin/product/${encodeURIComponent(productId)}/color`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateColorVariant(productId, colorId, body) {
  return apiFetch(
    `/api/admin/product/${encodeURIComponent(productId)}/color/${encodeURIComponent(colorId)}`,
    { method: "PUT", body: JSON.stringify(body) }
  );
}

export function deleteColorVariant(productId, colorId) {
  return apiFetch(
    `/api/admin/product/${encodeURIComponent(productId)}/color/${encodeURIComponent(colorId)}`,
    { method: "DELETE" }
  );
}

export function addColorVariantImage(productId, colorId, file) {
  const form = new FormData();
  form.append("file", file);
  return apiFetch(
    `/api/admin/product/${encodeURIComponent(productId)}/color/${encodeURIComponent(colorId)}/images`,
    { method: "POST", body: form }
  );
}

// Collections
export function fetchAdminCollections({ page = 1, pageSize = 15 } = {}) {
  const qs = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  return apiFetch(`/api/admin/collection?${qs}`);
}

export function fetchAdminCollection(collectionId) {
  return apiFetch(`/api/admin/collection/${encodeURIComponent(collectionId)}`);
}

export function createAdminCollection(body) {
  return apiFetch(`/api/admin/collection`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateAdminCollection(collectionId, body) {
  return apiFetch(`/api/admin/collection/${encodeURIComponent(collectionId)}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
}

export function deleteAdminCollection(collectionId) {
  return apiFetch(`/api/admin/collection/${encodeURIComponent(collectionId)}`, {
    method: "DELETE",
  });
}

export function uploadCollectionImage(collectionId, file) {
  const form = new FormData();
  form.append("file", file);
  return apiFetch(`/api/admin/collection/${encodeURIComponent(collectionId)}/image`, {
    method: "PUT",
    body: form,
  });
}

// Stock
export function fetchAdminStock({ page = 1, pageSize = 15 } = {}) {
  const qs = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  return apiFetch(`/api/admin/stock?${qs}`);
}

export function setAdminStock(productId, body) {
  return apiFetch(`/api/admin/stock/${encodeURIComponent(productId)}`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

// Fast Stock Update
export function fetchProductVariantsByCode(code) {
  return apiFetch(`/api/admin/product/dummy/variants?Code=${encodeURIComponent(code)}`);
}

export function fetchVariantStock(productId, colorId, sizeId) {
  return apiFetch(
    `/api/admin/stock/variant/${encodeURIComponent(productId)}/${encodeURIComponent(colorId)}/${encodeURIComponent(sizeId)}`
  );
}

export function adminSetOrderLosses(orderId, losses) {
  return apiFetch(`/api/admin/orders/${encodeURIComponent(orderId)}/losses`, {
    method: "POST",
    body: JSON.stringify({ losses }),
  });
}

// Coupons
export function fetchAdminCoupons({ page = 1, pageSize = 50, isEnabled } = {}) {
  const qs = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  if (isEnabled !== undefined && isEnabled !== null && isEnabled !== "") {
    qs.set("isEnabled", String(isEnabled));
  }
  return apiFetch(`/api/admin/coupon?${qs}`);
}

export function fetchAdminCoupon(couponId) {
  return apiFetch(`/api/admin/coupon/${encodeURIComponent(couponId)}`);
}

export function createAdminCoupon(body) {
  return apiFetch(`/api/admin/coupon`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateAdminCoupon(couponId, body) {
  return apiFetch(`/api/admin/coupon/${encodeURIComponent(couponId)}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
}

export function deleteAdminCoupon(couponId) {
  return apiFetch(`/api/admin/coupon/${encodeURIComponent(couponId)}`, {
    method: "DELETE",
  });
}

export function fetchAdminDashboardStats(days = 30) {
  return apiFetch(`/api/admin/dashboard/statistics?days=${encodeURIComponent(days)}`);
}



